(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/toLower', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/toLower'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.toLower, global.convert);
    global.toLower = mod.exports;
  }
})(this, function (exports, _toLower2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.toLower = undefined;

  var _toLower3 = _interopRequireDefault(_toLower2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Converts string, as a whole, to lower case just like String#toLowerCase.
   * @function
   * @memberof string
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @return {Object} Returns the updated object.
   * @example toLower({ nested: { a: "A STRING" } }, 'nested.a') // => { nested: { a: "a string" } }
   * @see {@link https://lodash.com/docs#toLower|lodash.toLower} for more information.
   * @see {@link https://mdn.io/String/toLowerCase|String.toLowerCase} for more information.
   * @since 0.3.0
   */
  var toLower = (0, _convert.convert)(_toLower3.default);
  exports.toLower = toLower;
  exports.default = toLower;
});